module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-header.5e950558.png";